export const mockData = {
  products: [
    {
      id: 1,
      name: "Ragi Bhujia - Achari Flavour",
      description: "Made with wholesome Ragi (Millet). No Maida, Baked to perfection. Heart-healthy & protein-rich snack.",
      type: "Baked",
      price: 175,
      originalPrice: 200,
      images: [
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/yxyr3osu_Ragi%20Bhujai%20Infographics.png",
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/fmy7e8qz_Ragi%20Bhujia%20Front.png",
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/k9lmobbx_Pack%20of%205%20ragi%20bhujia%20save%2020%25.png"
      ],
      badge: "🔥 Bestseller",
      nutrition: {
        protein: "17g",
        sugar: "4g",
        fat: "4g"
      }
    },
    {
      id: 2,
      name: "Baked Multigrain Bhujia - Pudina Flavour",
      description: "Chatpata crunchy namkeen made with nutritious multigrains. No Maida, Baked Not Fried. Heart-healthy snack with authentic pudina flavor.",
      type: "Baked",
      price: 175,
      originalPrice: 200,
      images: [
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/5i3whfqr_Multigrain%20Bhujia%20Infographics.png",
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/gc37owxd_Multigrain%20Bhujia_Front.png",
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/wocrjhoz_Multigrain%20Buy%205%20and%20save%2020%25.png"
      ],
      badge: "🌶️ Hot Pick",
      nutrition: {
        protein: "19g",
        sugar: "1.5g",
        fat: "11.9g"
      }
    },
    {
      id: 3,
      name: "Jowar & Jeera Cookies - Pack of 5",
      description: "Made with Jaggery sweetness. No Maida, No Palm Oil, No Added Refined Sugar. All natural ingredients for guilt-free snacking. Pack of 5 cookies.",
      type: "Baked",
      price: 180,
      originalPrice: 200,
      images: [
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/y0n0ftbq_Jowar%20Jeera%20Cookies%20Infographic.png",
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/8ytt0wny_Jowar%20Jeera%20Cookies%20Front.png",
        "https://customer-assets.emergentagent.com/job_roastey-snacks/artifacts/9of9ozwv_Jowar%20Jeera%20Cookies%20Buy%205%20and%20save%2020%25.png"
      ],
      badge: "🌾 New",
      nutrition: {
        protein: "8g",
        sugar: "20.41g",
        fat: "25.76g"
      }
    }
  ],

  benefits: [
    {
      icon: "zap",
      title: "Protein Packed",
      description: "Every bite is loaded with plant-based protein to keep you fueled. Build muscle, not guilt. Your gains will thank you later."
    },
    {
      icon: "heart",
      title: "Heart Healthy",
      description: "Baked or roasted, never fried. Good fats, zero bad vibes. Because we care about your ticker as much as you do."
    },
    {
      icon: "flame",
      title: "Flavor Explosion",
      description: "Who said healthy can't be tasty? Our masalas and seasonings are chef's kiss. Boring snacks? We don't know her."
    }
  ],

  testimonials: [
    {
      name: "Priya Sharma",
      location: "Mumbai",
      rating: 5,
      review: "Finally, snacks that don't make me feel like I'm betraying my fitness goals. The masala mix is literally addictive!"
    },
    {
      name: "Arjun Mehta",
      location: "Bangalore",
      rating: 5,
      review: "Bro, these are bussin! I keep a pack in my gym bag. Perfect post-workout snack. No cap."
    },
    {
      name: "Sneha Patel",
      location: "Delhi",
      rating: 5,
      review: "My 3 PM cravings are sorted. High protein, amazing taste, and I don't feel guilty munching at work. 10/10 would recommend!"
    }
  ]
};
